// src/app/modules/BulkUpload/hooks/useBulkUpload.js

import { useContext } from 'react';
import { BulkUploadContext } from '../context/BulkUploadContext';

export const useBulkUpload = () => {
  const context = useContext(BulkUploadContext);
  
  if (!context) {
    throw new Error('useBulkUpload must be used within BulkUploadProvider');
  }
  
  return context;
};